<template>
    <div id="app">

    <vs-row vs-type="flex" vs-justify="space-between" >
      <vs-col  vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="3">
        <vs-button @click="newEvent" color="primary" type="filled">+ Spa</vs-button>
      </vs-col>
    </vs-row>

    <br/>
    <vs-popup  :active.sync="showModal" :title="title" @close="closepop" fullscreen>
        <vs-row vs-justify="center" >
            <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">

                <br/>
                <vs-row class="custom2" vs-w="12">                       
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <h5>Nome</h5>
                    </vs-col>
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="5" vs-sm="5" vs-xs="12" >
                        <vs-input class="w-full" v-model="rowSelected.name" v-validate="'required'" name="name" autocomplete="off" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                    </vs-col>                      
                </vs-row> 

                <br/>                    
                <vs-row class="custom2" vs-w="12">                    
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <h5>Hotel</h5>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="12" >
                        
                        <v-select
                            class="selectWidth300"
                            v-model="rowSelected.hotel_id" 
                            @input-change="autoCompleteFunc"
                            name="hvg_nome"
                            autocomplete
                            id="rowSelected-hotel_id" 
                            ref="hotel_id"
                            :options="hoteisvg"
                            label="hvg_nome"
                            v-validate="'required'"
                            :clearable='false'
                        >
                            <span slot="no-options"> --- </span>
                        </v-select>

                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <span class="text-danger text-sm" v-show="errors.has('hvg_nome')">{{ errors.first('hvg_nome') }}</span>
                    </vs-col>   
                </vs-row>  

                <br/>                   
                <vs-row class="custom2" vs-w="12">                   
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <h5>Armazém</h5>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="12" >
                        <v-select
                            autocomplete
                            placeholder=""
                            class="selectWidth200"
                            v-model="rowSelected.warehouse"
                            v-validate="'required'"
                            name="armazem" 
                            id="rowSelected-armazem_id"
                            label="armazem"
                            :clearable="false" 
                            :options="armazensvg"
                        >     
                
                        </v-select>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <span class="text-danger text-sm" v-show="errors.has('armazem')">{{ errors.first('armazem') }}</span>
                    </vs-col>   
                </vs-row>  
                
                <br/>
                <vs-row class="custom2" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <h5>Hora de Abertura</h5>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="12" >
                        <flat-pickr :config="configdateTimePicker"  placeholder="HH:MM" v-model="rowSelected.opening_time" 
                            v-validate="'required'"
                            name="openingTime"
                        />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <span class="text-danger text-sm" v-show="errors.has('openingTime')">{{ errors.first('openingTime') }}</span>
                    </vs-col>
                </vs-row>  

                <br/>
                <vs-row class="custom2" vs-w="12">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <h5>Hora de Encerramento</h5>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="12" >
                        <flat-pickr :config="configdateTimePicker"  placeholder="HH:MM" v-model="rowSelected.closing_time"
                        v-validate="'required'"
                        name="closingTime"
                        />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <span class="text-danger text-sm" v-show="errors.has('closingTime')">{{ errors.first('closingTime') }}</span>
                    </vs-col>
                </vs-row> 

                <br/>
                <vs-row class="custom2" vs-w="12">
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <h5>Exploração</h5>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="12" >
                        <vs-checkbox v-model="rowSelected.exploration" vs-value="1" :disabled="displayEdit == true"></vs-checkbox>
                    </vs-col>
                </vs-row>
                
                <br/>
                <vs-row v-if="rowSelected.exploration == '1'" class="custom2" vs-w="12">
                    <vs-row class="mb-5">
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                            <h5>Gestor</h5>
                        </vs-col>
                        <vs-col vs-type="inline" vs-justify="left" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="12" >
                            <vue-simple-suggest
                                placeholder="Nome ou ID"
                                v-model="rowSelected.manager_id"
                                :list="getListManagers"
                                :filter-by-query="false"
                                :max-suggestions="20"
                                :min-length="3"
                                :debounce="500"
                                ref="suggestmanager"
                                mode="select"
                                value-attribute="cod_pessoa"
                                display-attribute="nome"
                                @select="onSuggestSelect"
                            >                            
                            </vue-simple-suggest>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >                        
                            <span class="text-danger text-sm" v-show="manager_error == true">Campo Obrigatório</span>
                        </vs-col>
                    </vs-row>
                    <vs-row class="">
                        <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                            <h5>Entidade</h5>
                        </vs-col>
                        <vs-col vs-type="inline" vs-justify="left" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="12" >
                            <vue-simple-suggest
                                placeholder="Nome ou ID"
                                v-model="rowSelected.company"
                                :list="getListCompanies"
                                :max-suggestions="20"
                                :min-length="3"
                                :debounce="500"
                                :filter-by-query="false"
                                :prevent-submit="true"   
                                mode="select"
                                :nullable-select="true"
                                ref="suggestComponent"
                                value-attribute="cod_entidade"
                                display-attribute="entidade"
                                @select="onSuggestSelect"
                                name="entidade"                
                            >
                            </vue-simple-suggest>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >                        
                            <span class="text-danger text-sm" v-show="company_error == true">Campo Obrigatório</span>
                        </vs-col>
                    </vs-row>
                </vs-row> 

                <br/>
                <vs-row class="custom2" vs-w="12">                  
                    <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <h5>Estado</h5>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-lg="5" vs-sm="5" vs-xs="12" >
                        <vs-radio v-model="rowSelected.status" vs-value="1" color="primary"
                            v-validate="'required'"
                            name="status" 
                        >
                            Activo
                        </vs-radio>
                        &nbsp;&nbsp;&nbsp;
                        <vs-radio v-model="rowSelected.status" vs-value="0" color="danger"
                                v-validate="'required'"
                            name="status" 
                        >
                            Inactivo
                        </vs-radio>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="12" >
                        <span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
                    </vs-col>
                </vs-row> 

                <br/>
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">                    
                    <vs-button v-if="displayNew" @click="addSpa()" class="mr-3 mb-2" icon-pack="feather" icon="icon-check-circle" >Novo</vs-button>
                    <vs-button v-if="displayEdit" @click="editSpa()" class="mr-3 mb-2" icon-pack="feather" icon="icon-check-circle" >Guardar</vs-button>
                    <vs-button color="warning" type="border" class="mb-2" 
                        @click="clearFields"
                        icon-pack="feather" icon="icon-delete"
                    >
                        Limpar
                    </vs-button>                
                </vs-row>
            </vs-col>
        </vs-row>
        </vs-popup>

        <vs-table            
            v-model="selectedSpa"
            pagination
            max-items="10"
            search
            noDataText="Não foram encontrados registos"
            @selected="handleSpa"
            :data="spas"
        >
        <template slot="header">
            <h3>
            Lista de Spas
            </h3>
        </template>
        
        <template slot="thead">
            <vs-th>
            </vs-th>
            <vs-th>
                Nome
            </vs-th>
            <vs-th>
                Hotel
            </vs-th>
            <vs-th>
                Hora Abertura
            </vs-th>
            <vs-th>
                Hora Encerramento
            </vs-th>
            <vs-th>
                Estado
            </vs-th>
        </template>
        
        <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="indextr % 2 == 0 ?'primary':indextr == 668?'danger':null">
                <vs-td :data="data[indextr].name">
                </vs-td>
                <vs-td :data="data[indextr].name">
                {{data[indextr].name}}
                </vs-td>

                <vs-td :data="data[indextr].hvg_nome">
                {{data[indextr].hvg_nome}} 
                </vs-td>

                <vs-td :data="data[indextr].opening_time">
                {{data[indextr].opening_time}}
                </vs-td>

                <vs-td :data="data[indextr].closing_time">
                {{data[indextr].closing_time}}
                </vs-td>

                <vs-td v-if="data[indextr].status == 0" :data="data[indextr].status">
                    Inactivo
                </vs-td>
                <vs-td v-if="data[indextr].status == 1" :data="data[indextr].status">
                    Activo
                </vs-td>
            </vs-tr>
        </template>
        </vs-table>

    </div>
</template>

<script>

import themeConfig from '@/../themeConfig.js';

import Datepicker from 'vuejs-datepicker';                          
import vSelect from 'vue-select';                                  
import flatPickr from 'vue-flatpickr-component';                   
import 'flatpickr/dist/flatpickr.css';

import axios from "axios";

import VueSimpleSuggest from 'vue-simple-suggest';
import 'vue-simple-suggest/dist/styles.css';

import { Validator } from 'vee-validate';

const dict = {
  custom: {
    name: { 
      required: 'Campo Obrigatório ',
      alpha_spaces: 'Por favor introduza apenas nomes e espaços',
    },
    hvg_nome: {
        required: 'Campo Obrigatório ',
    },
    openingTime: {
        required: 'Campo Obrigatório ',
    },
    closingTime: {
        required: 'Campo Obrigatório ',
    },
    status: {
        required: 'Campo Obrigatório ',
    },
    armazem: {
        required: 'Campo Obrigatório ',
    },
    manager: {
        required: 'Campo Obrigatório ',
    },
  }
};

Validator.localize('pt', dict);

export default{
    name: 'spa',
    props: [
        'spaSelected',  
        'spaInitial',
        'hotelSelected',
    ],
    data: function() {
        return {
            configdateTimePicker: 
            {              
                enableTime: true,
                enableSeconds: false,
                noCalendar: true,
                time_24hr: true,                    
                defaultHour	: '00',
            },
            
            displayNew :false,
            displayEdit : false,
            showModal: false,  
            title: '',
            spa_id: '',
            spa: [],
            selectedSpa : [],
            spas: [],
            armazensvg: [],
            rowSelected: {
                hotel_id: '',
                exploration: 0,
                manager_id: '',
                company: '',
            },

            manager_error: false,
            company_error: false,
            spasTemp: [],
        }
    },

    components: {
        Datepicker,              
        'v-select': vSelect,      
        flatPickr,               
        VueSimpleSuggest,
    },

    methods: {
        closepop(){
            if(this.$validator.errors.items.length > 0)
            {                   
                while(this.$validator.errors.items.length > 0)
                {
                    this.$validator.errors.items.pop();
                }
            }

            this.manager_error = false;
            this.company_error = false;

            this.showModal = false; 
        },

        newEvent() {
            this.title = 'Adicionar Spa';

            if(this.$validator.errors.items.length > 0)
            {                   

                while(this.$validator.errors.items.length > 0)
                {
                    this.$validator.errors.items.pop();
                }
            }

            this.showModal = true;

            this.displayNew = true;
            this.displayEdit = false;

            let x = document.getElementById('rowSelected-hotel_id').getElementsByTagName('input')[0];
            let y = document.getElementById('rowSelected-armazem_id').getElementsByTagName('input')[0];  

            let att1 =  document.createAttribute("autocomplete");
            let att2 =  document.createAttribute("autocomplete");
            att1.value = "off";
            att2.value = "off";

            x.setAttributeNode(att1);
            y.setAttributeNode(att2);
        },

        addSpa() {
            if(this.rowSelected.exploration == '1' && (this.rowSelected.manager_id == null || this.rowSelected.manager_id == '' || this.$refs.suggestmanager.text == '')){
                this.manager_error = true;
            }else{
                this.manager_error = false;
            }
            if(this.rowSelected.exploration == '1' && (this.rowSelected.company == null || this.rowSelected.company == '' || this.$refs.suggestComponent.text == '')){
                this.company_error = true;
            }else{
                this.company_error = false;
            }

            this.$validator.validateAll().then(result => {
                if(this.manager_error){
                    return false;
                }
                if(this.company_error){
                    return false;
                }

                if (result){   
                    let that = this;
        
                    axios({
                        method: 'post',
                        url: themeConfig.apiurl + '/spa/new/spa',
                        data: {
                            spa: this.rowSelected,
                            token: window.localStorage.getItem('usertoken'),
                        }
                    }).then(function (response) { 
                        if(response.status == 200){
                            if(that.spaInitial == null || that.spaInitial == 0){
                                that.$emit('loadSchedulerSpaTemp', response.data.spa_id);
                            }
                            that.$store.dispatch('addSpa',response.data);

                            that.notify('Registo inserido com sucesso', 'green');

                            that.showModal = false;

                            that.manager_error = false;
                            that.company_error = false;

                            that.getSpas();
                            
                        }        
                    }).catch(function (error){
                        console.log(error.response);
                    });
                }
            });

        }, 

        handleSpa(tr){
            this.title ='Editar Spa';  
          
            this.rowSelected = JSON.parse(JSON.stringify(tr));

            if(this.rowSelected.exploration != '1'){
                this.rowSelected.exploration = '';
            }

            this.showModal = true;

            this.displayNew = false;
            this.displayEdit = true;
        },

        editSpa(event) {
            if(this.rowSelected.exploration == '1' && this.rowSelected.manager_id != null && this.rowSelected.manager_id != ''){
                this.manager_error = false;
            }else if(this.rowSelected.exploration == '0' || this.rowSelected.exploration == ''){
                this.manager_error = false;
            }else{
                if(this.rowSelected.manager_id == null && this.selectedSpa.manager_id != null && this.selectedSpa.manager_id != ''){
                    this.manager_error = false;
                }else{
                    this.manager_error = true;
                }
            }
            if(this.rowSelected.exploration == '1' && this.rowSelected.manager_id != null && this.rowSelected.manager_id != ''){
                this.manager_error = false;
            }else if(this.rowSelected.exploration == '0' || this.rowSelected.exploration == ''){
                this.manager_error = false;
            }else{
                if(this.rowSelected.manager_id == null && this.selectedSpa.manager_id != null && this.selectedSpa.manager_id != ''){
                    this.manager_error = false;
                }else{
                    this.manager_error = true;
                }
            }

            if(this.rowSelected.exploration == '1' && this.rowSelected.company != null && this.rowSelected.company != ''){
                this.company_error = false;
            }else if(this.rowSelected.exploration == '0' || this.rowSelected.exploration == ''){
                this.company_error = false;
            }else{
                if(this.rowSelected.company == null && this.selectedSpa.company != null && this.selectedSpa.company != ''){
                    this.company_error = false;
                }else{
                    this.company_error = true;
                }
            }
            if(this.rowSelected.exploration == '1' && this.rowSelected.company != null && this.rowSelected.company != ''){
                this.company_error = false;
            }else if(this.rowSelected.exploration == '0' || this.rowSelected.exploration == ''){
                this.company_error = false;
            }else{
                if(this.rowSelected.company == null && this.selectedSpa.company != null && this.selectedSpa.company != ''){
                    this.company_error = false;
                }else{
                    this.company_error = true;
                }
            }
        
            this.$validator.validateAll().then(result => {
                if(this.manager_error){
                    return false;
                }
                if(this.company_error){
                    return false;
                }

                if (result){
                    let that = this; 

                    axios({
                        method: 'put',
                        url: themeConfig.apiurl + '/spa/modify/spa/' + this.rowSelected.spa_id,
                        data: {
                            spa: that.rowSelected,
                            token: window.localStorage.getItem('usertoken'),
                        }
                    }).then(function (response){                          
                        if(response.status == 200){
                            that.notify('Registo modificado com sucesso', 'green');

                            that.showModal = false;

                            that.getSpas();
                        }        
                    }).catch(function (error){                            
                        console.log(error);
                    });
                }
            });
            
        },

        // spasvgbyUser() { 
        //     let session = JSON.parse(window.localStorage.getItem('userSession'));  

        //     let that = this;
        //     axios({
        //         method: 'get',
        //         url: themeConfig.apiurl + '/spa/spas/byTherapist/' + session.id + '?token='+window.localStorage.getItem('usertoken'),
        //     }).then(function (res) { 
        //         if(res.status == 200){ 
        //             that.spasTemp = res.data.map(function(item, index){
        //                 item.label = item.name + ' | ' + item.hvg_nome;
        //                 return item;
        //             });
        //             that.$emit('spaListSelect', that.spasTemp);
        //         }                                      
        //     }).catch( function (err) {
        //         console.log(err);
        //     })
        // },
        
        clearFields(){ 
            Object.keys(this.rowSelected).forEach(k =>  this.rowSelected[k] = '');    //reset properties values of the object 

            this.rowSelected.exploration = 0;

            this.armazensvg = [];
        },

        getSpas(){
            this.$vs.loading();
            let that = this;
            let session = JSON.parse(window.localStorage.getItem('userSession'));
    
            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/spas?token=' + window.localStorage.getItem('usertoken'),
                params: {
                    role_id: session.userType,
                    is_director: session.isSpaDirector ? 1 : 0,
                    cod_pessoa: session.id,
                }
            }).then(function (res) { 
                if(res.status == 200){   
                     
                    that.spas = res.data;

                    that.$store.dispatch('addSpa', res.data);
                }                                                      
            }).catch( function (err) {
                console.log(err);
            }).then(function (res){
                that.$vs.loading.close(); 
            })
        },

        getArmazensbyHotel(){
            this.$vs.loading();
            let that = this;

            axios({
                method: 'get',
                url: themeConfig.apiurl + '/spa/storage/byHotel/' + this.rowSelected.hotel_id.hvg_id+'?token='+window.localStorage.getItem('usertoken'),
            })
            .then(function (response) {                           
                if(response.status == 200){   
                    that.armazensvg = response.data;
                }        
            })
            .catch(function (error){
                console.log(error);
            })
            .then(function (res){
                that.$vs.loading.close(); 
            });
        },

        getListCompanies(inputValue){
            let that = this;

            this.$vs.loading();
           
            return new Promise((resolve, reject) => {

                let url = themeConfig.apiurl + '/autocomplete/entity/nameOrId?company=' + inputValue + '&token='+window.localStorage.getItem('usertoken');
                fetch(url).then(response => 
                {
                    if (!response.ok) 
                    {
                        reject()
                        that.$vs.loading.close();
                    }

                    response.json().then(json => 
                    {
                        resolve(json)               
                        that.$vs.loading.close();   

                    }).catch(e => 
                    {
                        reject(e)
                        that.$vs.loading.close();  
                    });
                }).catch(error => {
                    this.loading = false
                    reject(error)
                    that.$vs.loading.close();
                })
            }) ;
        },

        autoCompleteFunc(){
            this.rowSelected.armazem_id = '';     
        },

        getListManagers(inputValue){    
            let that = this;

            this.$vs.loading();
            
            return new Promise((resolve, reject) => {
                let url = themeConfig.apiurl + '/spa/managers?input=' + inputValue + '&token='+window.localStorage.getItem('usertoken');
                fetch(url).then(response => {
                    if (!response.ok) {
                        reject()
                        that.$vs.loading.close();
                    }

                    response.json().then(json => {
                        resolve(json)               
                        that.$vs.loading.close();

                    }).catch(e => {
                        reject(e)
                        that.$vs.loading.close();   
                    })
                }).catch(error => {
                    this.loading = false
                    reject(error)
                    that.$vs.loading.close();   
                })
            });  
        },   

        onSuggestSelect(suggest){   
            if(suggest != null){
                this.selected = suggest;                
            }
        },
    }, 

    created() {
        this.getSpas();
    },

    computed: {
        hoteisvg() {      
            let session = JSON.parse(window.localStorage.getItem('userSession'));
            if (session.userType == 7) {
                return this.$store.state.hoteisvg;
            } else {
                if(session.hotel){
                    return this.$store.state.hoteisvg.filter(hotel => hotel.hvg_id == session.hotel.id);
                } else {
                    return this.$store.state.hoteisvg;
                }
            }
        },
    }, 

    watch: {
        showModal(new_val,old_val) {
            if(!new_val){
                this.clearFields(); 
            }
        },

        'rowSelected.hotel_id': function(new_val,old_val){ 
            if(new_val !== 'undefined' && new_val !==  old_val && new_val !== '')
            {   
                if(old_val !== new_val && old_val !== '') 
                {
                    this.rowSelected.armazem_id = '';
                }

                this.getArmazensbyHotel();
            }
        },

        'rowSelected.exploration': function(new_val,old_val){
            if(new_val === null && (this.displayNew || this.displayEdit)){
                this.rowSelected.manager_id = null;
                this.rowSelected.company = null;
                this.rowSelected.exploration = 0;   
            }
        },
    },
}

</script>
